var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3959 0.907227C13.8133 0.907227 14.2136 1.07304 14.5088 1.36819C14.8039 1.66335 14.9697 2.06366 14.9697 2.48107V13.4979C14.9697 13.9153 14.8039 14.3157 14.5088 14.6108C14.2136 14.906 13.8133 15.0718 13.3959 15.0718H2.37901C1.96161 15.0718 1.56129 14.906 1.26614 14.6108C0.97099 14.3157 0.805176 13.9153 0.805176 13.4979V2.48107C0.805176 2.06366 0.97099 1.66335 1.26614 1.36819C1.56129 1.07304 1.96161 0.907227 2.37901 0.907227H13.3959ZM13.0024 13.1045V8.93381C13.0024 8.25343 12.7321 7.60092 12.2511 7.11982C11.77 6.63873 11.1174 6.36845 10.4371 6.36845C9.76819 6.36845 8.98914 6.77765 8.61142 7.39144V6.51796H6.41591V13.1045H8.61142V9.22497C8.61142 8.61904 9.09931 8.12328 9.70524 8.12328C9.99742 8.12328 10.2776 8.23935 10.4842 8.44595C10.6909 8.65256 10.8069 8.93278 10.8069 9.22497V13.1045H13.0024ZM3.85842 5.2825C4.20905 5.2825 4.54531 5.14321 4.79324 4.89529C5.04116 4.64736 5.18045 4.3111 5.18045 3.96047C5.18045 3.22864 4.59026 2.63058 3.85842 2.63058C3.50571 2.63058 3.16745 2.77069 2.91805 3.0201C2.66864 3.2695 2.52853 3.60776 2.52853 3.96047C2.52853 4.69231 3.12659 5.2825 3.85842 5.2825ZM4.95224 13.1045V6.51796H2.77247V13.1045H4.95224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.75d18a02f10a09ba880f354e76867016.svg";
export { ForwardRef as ReactComponent };